var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c(
        "el-tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showWarningImage,
              expression: "showWarningImage"
            }
          ],
          attrs: { content: _vm.warningImageTip, placement: "right-end" }
        },
        [
          _c("i", {
            staticClass: "el-icon-warning red",
            staticStyle: { cursor: "pointer", "font-size": "14px" }
          })
        ]
      ),
      _c(
        "el-tooltip",
        {
          attrs: {
            disabled: !_vm.tooltip || !_vm.tooltipContent,
            content: _vm.tooltipContent,
            placement: "bottom-end"
          }
        },
        [
          _c("cargo-advance-select", {
            ref: "company",
            attrs: {
              disabled: _vm.disabled,
              "select-type": _vm.selectTypeNames.basic_data_Company,
              "method-params": _vm.methodParams,
              headers:
                _vm.headers && _vm.headers.length > 0 ? _vm.headers : undefined,
              fields:
                _vm.fields && _vm.fields.length > 0 ? _vm.fields : undefined,
              "tag-name": _vm.tagName,
              filterable: "",
              "default-value": _vm.value,
              placeholder: _vm.placeholder || undefined,
              "static-options": _vm.staticOptions,
              "data-filter-function": _vm.dataFilterFunction
            },
            on: {
              parentCallBack: _vm.onParentCallBack,
              focus: function($event) {
                return _vm.$emit("focus")
              },
              blur: function($event) {
                return _vm.$emit("blur")
              },
              clear: function($event) {
                return _vm.$emit("clear")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }